<div #imageContainer class="w-100" style="border-radius: 0.25em; aspect-ratio: 1/1; overflow: hidden;">
  <ng-container *ngIf="isOnBrowserNow; else fallbackImg">
    <div [ngClass]="['w-100', 'h-100', imgClass]" [style.transform]="'rotate(' + rotationInDegrees + 'deg)'"
      [style.background-image]="'url(' + imgSrc + '), url(../../../assets/images/shop/default.png)'"
      [style.background-repeat]="'no-repeat'" [style.background-size]="backgroundWidth + ' ' + backgroundHeight"
      [style.background-position]="backgroundPositionX + ' ' + backgroundPositionY">
    </div>
  </ng-container>
  <ng-template #fallbackImg>
    <div class="w-100 h-100">
      <img [src]="imgSrc" [alt]="imgAlt" (error)="commonService.handleError($event)" class="img-pro" />
    </div>
  </ng-template>
</div>